import {
  configureStore,
  combineReducers,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { Dispatch, AnyAction } from "redux";
import { useDispatch } from "react-redux";
import logger from "redux-logger";
import AsyncStorage from "@react-native-community/async-storage";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import authSlice from "./auth";
import consentFlowSlice from "./consentFlow";

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  consentFlow: consentFlowSlice.reducer,
});

const persistConfig = {
  key: "@bodyart",
  storage: AsyncStorage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    logger,
  ],
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): Dispatch<AnyAction> =>
  useDispatch<AppDispatch>();

export const persistor = persistStore(store);

export default store;
